function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  query ChatbotConfigQuery($context: ContextInput!, $applicationName: String!) {\n    chatbotConfig(context: $context, applicationName: $applicationName) {\n      authToken\n      channelOriginId\n      chatbotCapabilities\n      conversationProperties {\n        launchPoint\n        traceId\n      }\n      enableAutoOpenChatWidget\n      enableProactiveConversation\n      version {\n        javascriptUrl {\n          value\n        }\n        versionId\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  query localChatClient {\n    localChatClientState @client {\n      requested\n      isEventHandlerRegistered\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var __defProp = Object.defineProperty;
var __defNormalProp = function(obj, key, value) {
    return key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var __publicField = function(obj, key, value) {
    __defNormalProp(obj, (typeof key === "undefined" ? "undefined" : _type_of(key)) !== "symbol" ? key + "" : key, value);
    return value;
};
// src/components/virtual-agent-control.tsx
import React from "react";
import { gql, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { useLogger } from "@shared-ui/logger-context";
import { useProvidedState } from "@shared-ui/provided-state-context";
function getChatClientFromDOM(authToken) {
    return _getChatClientFromDOM.apply(this, arguments);
}
function _getChatClientFromDOM() {
    _getChatClientFromDOM = // src/components/helpers/virtual-agent-control-helpers.ts
    _async_to_generator(function(authToken) {
        var _window, _window1;
        return _ts_generator(this, function(_state) {
            if (typeof window !== "undefined") {
                ;
                if ((_window = window) === null || _window === void 0 ? void 0 : _window.virtualAgentControl) {
                    return [
                        2,
                        window.virtualAgentControl
                    ];
                }
                if ((_window1 = window) === null || _window1 === void 0 ? void 0 : _window1.VacClientAdapter) {
                    return [
                        2,
                        window.VacClientAdapter.getInstance(authToken)
                    ];
                }
            }
            return [
                2,
                void 0
            ];
        });
    });
    return _getChatClientFromDOM.apply(this, arguments);
}
function getInitedChatClientFromDOM() {
    return _getInitedChatClientFromDOM.apply(this, arguments);
}
function _getInitedChatClientFromDOM() {
    _getInitedChatClientFromDOM = _async_to_generator(function() {
        var _window, _window_VirtualAgentControl, _window1, _window2, _tmp, isInit, chatInstance;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(typeof window !== "undefined")) return [
                        3,
                        6
                    ];
                    _tmp = (_window = window) === null || _window === void 0 ? void 0 : _window.virtualAgentControl;
                    if (!_tmp) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        window.virtualAgentControl.isInitialized
                    ];
                case 1:
                    _tmp = _state.sent();
                    _state.label = 2;
                case 2:
                    if (_tmp) {
                        return [
                            2,
                            window.virtualAgentControl
                        ];
                    }
                    if (!(((_window1 = window) === null || _window1 === void 0 ? void 0 : (_window_VirtualAgentControl = _window1.VirtualAgentControl) === null || _window_VirtualAgentControl === void 0 ? void 0 : _window_VirtualAgentControl.initialized) && ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.VacClientAdapter))) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        window.VirtualAgentControl.initialized
                    ];
                case 3:
                    isInit = _state.sent();
                    if (!isInit) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        window.VacClientAdapter.getInstance()
                    ];
                case 4:
                    chatInstance = _state.sent();
                    return [
                        4,
                        chatInstance.isInitialized
                    ];
                case 5:
                    if (_state.sent()) {
                        return [
                            2,
                            chatInstance
                        ];
                    }
                    _state.label = 6;
                case 6:
                    return [
                        2,
                        void 0
                    ];
            }
        });
    });
    return _getInitedChatClientFromDOM.apply(this, arguments);
}
function makeScript(javascriptUrl, onScriptLoad, onScriptLoadError) {
    var script = document.createElement("script");
    script.src = javascriptUrl;
    script.onload = onScriptLoad;
    script.onerror = onScriptLoadError;
    return script;
}
function adaptAuthToken(authToken) {
    if (typeof window.atob === "function") {
        var decoded = window.atob(authToken);
        var json = JSON.parse(decoded);
        return json;
    }
    return void 0;
}
function adaptChatbotCapabilities(capabilities) {
    var adaptedCapabilities = capabilities.map(function(capability) {
        switch(capability){
            case "CLICKSTREAM" /* CLICKSTREAM */ :
                {
                    return "Clickstream";
                }
            case "GLASSBOX" /* GLASSBOX */ :
                {
                    return "Glassbox";
                }
            default:
                {
                    return "";
                }
        }
    });
    return adaptedCapabilities.filter(function(value) {
        return value !== "";
    });
}
function adaptChatbotConfig(chatbotConfig, pageName, locale, authTokenForInit, clientOverrides) {
    var _clientOverrides, _chatbotConfig, _chatbotConfig1, _chatbotConfig2, _clientOverrides1, _clientOverrides_conversationProperties, _clientOverrides2, _chatbotConfig3, _chatbotConfig4, _clientOverrides3, _clientOverrides4, _chatbotConfig5, _clientOverrides5, _chatbotConfig6, _chatbotConfig7, _clientOverrides6, _clientOverrides7, _clientOverrides8, _clientOverrides9, _clientOverrides10, _clientOverrides11, _clientOverrides_conversationProperties1, _clientOverrides12, _clientOverrides_conversationProperties2, _clientOverrides13, _clientOverrides_conversationProperties3, _clientOverrides14, _clientOverrides_conversationProperties4, _clientOverrides15, _clientOverrides_conversationProperties5, _clientOverrides16, _clientOverrides_conversationProperties6, _clientOverrides17, _clientOverrides_conversationProperties7, _clientOverrides18, _clientOverrides_conversationProperties8, _clientOverrides19, _clientOverrides_conversationProperties9, _clientOverrides20, _clientOverrides_conversationProperties10, _clientOverrides21, _clientOverrides_conversationProperties11, _clientOverrides22, _clientOverrides_conversationProperties12, _clientOverrides23, _clientOverrides_conversationProperties13, _clientOverrides24, _clientOverrides_conversationProperties14, _clientOverrides25, _clientOverrides_conversationProperties15, _clientOverrides26, _clientOverrides27, _clientOverrides28, _clientOverrides29;
    var adaptedConfigs = {
        authToken: authTokenForInit,
        channelOriginId: ((_clientOverrides = clientOverrides) === null || _clientOverrides === void 0 ? void 0 : _clientOverrides.channelOriginId) || ((_chatbotConfig = chatbotConfig) === null || _chatbotConfig === void 0 ? void 0 : _chatbotConfig.channelOriginId),
        capabilities: ((_chatbotConfig1 = chatbotConfig) === null || _chatbotConfig1 === void 0 ? void 0 : _chatbotConfig1.chatbotCapabilities) ? adaptChatbotCapabilities((_chatbotConfig2 = chatbotConfig) === null || _chatbotConfig2 === void 0 ? void 0 : _chatbotConfig2.chatbotCapabilities) : [],
        containerElement: (_clientOverrides1 = clientOverrides) === null || _clientOverrides1 === void 0 ? void 0 : _clientOverrides1.containerElement,
        conversationProperties: {
            launchPoint: ((_clientOverrides2 = clientOverrides) === null || _clientOverrides2 === void 0 ? void 0 : (_clientOverrides_conversationProperties = _clientOverrides2.conversationProperties) === null || _clientOverrides_conversationProperties === void 0 ? void 0 : _clientOverrides_conversationProperties.launchPoint) || ((_chatbotConfig3 = chatbotConfig) === null || _chatbotConfig3 === void 0 ? void 0 : _chatbotConfig3.conversationProperties.launchPoint),
            traceId: (_chatbotConfig4 = chatbotConfig) === null || _chatbotConfig4 === void 0 ? void 0 : _chatbotConfig4.conversationProperties.traceId,
            pageName: pageName
        },
        embedded: (_clientOverrides3 = clientOverrides) === null || _clientOverrides3 === void 0 ? void 0 : _clientOverrides3.embedded,
        enableAutoOpenChatWidget: ((_clientOverrides4 = clientOverrides) === null || _clientOverrides4 === void 0 ? void 0 : _clientOverrides4.enableAutoOpenChatWidget) || ((_chatbotConfig5 = chatbotConfig) === null || _chatbotConfig5 === void 0 ? void 0 : _chatbotConfig5.enableAutoOpenChatWidget),
        enableProactiveConversation: ((_clientOverrides5 = clientOverrides) === null || _clientOverrides5 === void 0 ? void 0 : _clientOverrides5.enableProactiveConversation) || ((_chatbotConfig6 = chatbotConfig) === null || _chatbotConfig6 === void 0 ? void 0 : _chatbotConfig6.enableProactiveConversation),
        fastRender: ((_chatbotConfig7 = chatbotConfig) === null || _chatbotConfig7 === void 0 ? void 0 : _chatbotConfig7.version.versionId) === "V2" /* V2 */ ,
        intentMessage: (_clientOverrides6 = clientOverrides) === null || _clientOverrides6 === void 0 ? void 0 : _clientOverrides6.intentMessage,
        languageId: ((_clientOverrides7 = clientOverrides) === null || _clientOverrides7 === void 0 ? void 0 : _clientOverrides7.languageId) || locale,
        subscribedEvents: (_clientOverrides8 = clientOverrides) === null || _clientOverrides8 === void 0 ? void 0 : _clientOverrides8.subscribedEvents,
        eventHandler: (_clientOverrides9 = clientOverrides) === null || _clientOverrides9 === void 0 ? void 0 : _clientOverrides9.eventHandler,
        userProperties: (_clientOverrides10 = clientOverrides) === null || _clientOverrides10 === void 0 ? void 0 : _clientOverrides10.userProperties,
        configurationOverrides: (_clientOverrides11 = clientOverrides) === null || _clientOverrides11 === void 0 ? void 0 : _clientOverrides11.configurationOverrides
    };
    if ((_clientOverrides12 = clientOverrides) === null || _clientOverrides12 === void 0 ? void 0 : (_clientOverrides_conversationProperties1 = _clientOverrides12.conversationProperties) === null || _clientOverrides_conversationProperties1 === void 0 ? void 0 : _clientOverrides_conversationProperties1.skipWelcome) {
        var _clientOverrides_conversationProperties16, _clientOverrides30;
        adaptedConfigs.conversationProperties.skipWelcome = (_clientOverrides30 = clientOverrides) === null || _clientOverrides30 === void 0 ? void 0 : (_clientOverrides_conversationProperties16 = _clientOverrides30.conversationProperties) === null || _clientOverrides_conversationProperties16 === void 0 ? void 0 : _clientOverrides_conversationProperties16.skipWelcome;
    }
    if ((_clientOverrides13 = clientOverrides) === null || _clientOverrides13 === void 0 ? void 0 : (_clientOverrides_conversationProperties2 = _clientOverrides13.conversationProperties) === null || _clientOverrides_conversationProperties2 === void 0 ? void 0 : _clientOverrides_conversationProperties2.listingId) {
        var _clientOverrides_conversationProperties17, _clientOverrides31;
        adaptedConfigs.conversationProperties.listingId = (_clientOverrides31 = clientOverrides) === null || _clientOverrides31 === void 0 ? void 0 : (_clientOverrides_conversationProperties17 = _clientOverrides31.conversationProperties) === null || _clientOverrides_conversationProperties17 === void 0 ? void 0 : _clientOverrides_conversationProperties17.listingId;
    }
    if ((_clientOverrides14 = clientOverrides) === null || _clientOverrides14 === void 0 ? void 0 : (_clientOverrides_conversationProperties3 = _clientOverrides14.conversationProperties) === null || _clientOverrides_conversationProperties3 === void 0 ? void 0 : _clientOverrides_conversationProperties3.checkin) {
        var _clientOverrides_conversationProperties18, _clientOverrides32;
        adaptedConfigs.conversationProperties.checkin = (_clientOverrides32 = clientOverrides) === null || _clientOverrides32 === void 0 ? void 0 : (_clientOverrides_conversationProperties18 = _clientOverrides32.conversationProperties) === null || _clientOverrides_conversationProperties18 === void 0 ? void 0 : _clientOverrides_conversationProperties18.checkin;
    }
    if ((_clientOverrides15 = clientOverrides) === null || _clientOverrides15 === void 0 ? void 0 : (_clientOverrides_conversationProperties4 = _clientOverrides15.conversationProperties) === null || _clientOverrides_conversationProperties4 === void 0 ? void 0 : _clientOverrides_conversationProperties4.checkout) {
        var _clientOverrides_conversationProperties19, _clientOverrides33;
        adaptedConfigs.conversationProperties.checkout = (_clientOverrides33 = clientOverrides) === null || _clientOverrides33 === void 0 ? void 0 : (_clientOverrides_conversationProperties19 = _clientOverrides33.conversationProperties) === null || _clientOverrides_conversationProperties19 === void 0 ? void 0 : _clientOverrides_conversationProperties19.checkout;
    }
    if ((_clientOverrides16 = clientOverrides) === null || _clientOverrides16 === void 0 ? void 0 : (_clientOverrides_conversationProperties5 = _clientOverrides16.conversationProperties) === null || _clientOverrides_conversationProperties5 === void 0 ? void 0 : _clientOverrides_conversationProperties5.adults) {
        var _clientOverrides_conversationProperties20, _clientOverrides34;
        adaptedConfigs.conversationProperties.adults = (_clientOverrides34 = clientOverrides) === null || _clientOverrides34 === void 0 ? void 0 : (_clientOverrides_conversationProperties20 = _clientOverrides34.conversationProperties) === null || _clientOverrides_conversationProperties20 === void 0 ? void 0 : _clientOverrides_conversationProperties20.adults;
    }
    if ((_clientOverrides17 = clientOverrides) === null || _clientOverrides17 === void 0 ? void 0 : (_clientOverrides_conversationProperties6 = _clientOverrides17.conversationProperties) === null || _clientOverrides_conversationProperties6 === void 0 ? void 0 : _clientOverrides_conversationProperties6.children) {
        var _clientOverrides_conversationProperties21, _clientOverrides35;
        adaptedConfigs.conversationProperties.children = (_clientOverrides35 = clientOverrides) === null || _clientOverrides35 === void 0 ? void 0 : (_clientOverrides_conversationProperties21 = _clientOverrides35.conversationProperties) === null || _clientOverrides_conversationProperties21 === void 0 ? void 0 : _clientOverrides_conversationProperties21.children;
    }
    if ((_clientOverrides18 = clientOverrides) === null || _clientOverrides18 === void 0 ? void 0 : (_clientOverrides_conversationProperties7 = _clientOverrides18.conversationProperties) === null || _clientOverrides_conversationProperties7 === void 0 ? void 0 : _clientOverrides_conversationProperties7.pets) {
        var _clientOverrides_conversationProperties22, _clientOverrides36;
        adaptedConfigs.conversationProperties.pets = (_clientOverrides36 = clientOverrides) === null || _clientOverrides36 === void 0 ? void 0 : (_clientOverrides_conversationProperties22 = _clientOverrides36.conversationProperties) === null || _clientOverrides_conversationProperties22 === void 0 ? void 0 : _clientOverrides_conversationProperties22.pets;
    }
    if ((_clientOverrides19 = clientOverrides) === null || _clientOverrides19 === void 0 ? void 0 : (_clientOverrides_conversationProperties8 = _clientOverrides19.conversationProperties) === null || _clientOverrides_conversationProperties8 === void 0 ? void 0 : _clientOverrides_conversationProperties8.currency) {
        var _clientOverrides_conversationProperties23, _clientOverrides37;
        adaptedConfigs.conversationProperties.currency = (_clientOverrides37 = clientOverrides) === null || _clientOverrides37 === void 0 ? void 0 : (_clientOverrides_conversationProperties23 = _clientOverrides37.conversationProperties) === null || _clientOverrides_conversationProperties23 === void 0 ? void 0 : _clientOverrides_conversationProperties23.currency;
    }
    if ((_clientOverrides20 = clientOverrides) === null || _clientOverrides20 === void 0 ? void 0 : (_clientOverrides_conversationProperties9 = _clientOverrides20.conversationProperties) === null || _clientOverrides_conversationProperties9 === void 0 ? void 0 : _clientOverrides_conversationProperties9.device) {
        var _clientOverrides_conversationProperties24, _clientOverrides38;
        adaptedConfigs.conversationProperties.device = (_clientOverrides38 = clientOverrides) === null || _clientOverrides38 === void 0 ? void 0 : (_clientOverrides_conversationProperties24 = _clientOverrides38.conversationProperties) === null || _clientOverrides_conversationProperties24 === void 0 ? void 0 : _clientOverrides_conversationProperties24.device;
    }
    if ((_clientOverrides21 = clientOverrides) === null || _clientOverrides21 === void 0 ? void 0 : (_clientOverrides_conversationProperties10 = _clientOverrides21.conversationProperties) === null || _clientOverrides_conversationProperties10 === void 0 ? void 0 : _clientOverrides_conversationProperties10.bookNow) {
        var _clientOverrides_conversationProperties25, _clientOverrides39;
        adaptedConfigs.conversationProperties.bookNow = (_clientOverrides39 = clientOverrides) === null || _clientOverrides39 === void 0 ? void 0 : (_clientOverrides_conversationProperties25 = _clientOverrides39.conversationProperties) === null || _clientOverrides_conversationProperties25 === void 0 ? void 0 : _clientOverrides_conversationProperties25.bookNow;
    }
    if ((_clientOverrides22 = clientOverrides) === null || _clientOverrides22 === void 0 ? void 0 : (_clientOverrides_conversationProperties11 = _clientOverrides22.conversationProperties) === null || _clientOverrides_conversationProperties11 === void 0 ? void 0 : _clientOverrides_conversationProperties11.havId) {
        var _clientOverrides_conversationProperties26, _clientOverrides40;
        adaptedConfigs.conversationProperties.havId = (_clientOverrides40 = clientOverrides) === null || _clientOverrides40 === void 0 ? void 0 : (_clientOverrides_conversationProperties26 = _clientOverrides40.conversationProperties) === null || _clientOverrides_conversationProperties26 === void 0 ? void 0 : _clientOverrides_conversationProperties26.havId;
    }
    if ((_clientOverrides23 = clientOverrides) === null || _clientOverrides23 === void 0 ? void 0 : (_clientOverrides_conversationProperties12 = _clientOverrides23.conversationProperties) === null || _clientOverrides_conversationProperties12 === void 0 ? void 0 : _clientOverrides_conversationProperties12.site) {
        var _clientOverrides_conversationProperties27, _clientOverrides41;
        adaptedConfigs.conversationProperties.site = (_clientOverrides41 = clientOverrides) === null || _clientOverrides41 === void 0 ? void 0 : (_clientOverrides_conversationProperties27 = _clientOverrides41.conversationProperties) === null || _clientOverrides_conversationProperties27 === void 0 ? void 0 : _clientOverrides_conversationProperties27.site;
    }
    if ((_clientOverrides24 = clientOverrides) === null || _clientOverrides24 === void 0 ? void 0 : (_clientOverrides_conversationProperties13 = _clientOverrides24.conversationProperties) === null || _clientOverrides_conversationProperties13 === void 0 ? void 0 : _clientOverrides_conversationProperties13.hostname) {
        var _clientOverrides_conversationProperties28, _clientOverrides42;
        adaptedConfigs.conversationProperties.hostname = (_clientOverrides42 = clientOverrides) === null || _clientOverrides42 === void 0 ? void 0 : (_clientOverrides_conversationProperties28 = _clientOverrides42.conversationProperties) === null || _clientOverrides_conversationProperties28 === void 0 ? void 0 : _clientOverrides_conversationProperties28.hostname;
    }
    if ((_clientOverrides25 = clientOverrides) === null || _clientOverrides25 === void 0 ? void 0 : (_clientOverrides_conversationProperties14 = _clientOverrides25.conversationProperties) === null || _clientOverrides_conversationProperties14 === void 0 ? void 0 : _clientOverrides_conversationProperties14.chatbotName) {
        var _clientOverrides_conversationProperties29, _clientOverrides43;
        adaptedConfigs.conversationProperties.chatbotName = (_clientOverrides43 = clientOverrides) === null || _clientOverrides43 === void 0 ? void 0 : (_clientOverrides_conversationProperties29 = _clientOverrides43.conversationProperties) === null || _clientOverrides_conversationProperties29 === void 0 ? void 0 : _clientOverrides_conversationProperties29.chatbotName;
    }
    if ((_clientOverrides26 = clientOverrides) === null || _clientOverrides26 === void 0 ? void 0 : (_clientOverrides_conversationProperties15 = _clientOverrides26.conversationProperties) === null || _clientOverrides_conversationProperties15 === void 0 ? void 0 : _clientOverrides_conversationProperties15.chatbotEntryPoint) {
        var _clientOverrides_conversationProperties30, _clientOverrides44;
        adaptedConfigs.conversationProperties.chatbotEntryPoint = (_clientOverrides44 = clientOverrides) === null || _clientOverrides44 === void 0 ? void 0 : (_clientOverrides_conversationProperties30 = _clientOverrides44.conversationProperties) === null || _clientOverrides_conversationProperties30 === void 0 ? void 0 : _clientOverrides_conversationProperties30.chatbotEntryPoint;
    }
    if (((_clientOverrides27 = clientOverrides) === null || _clientOverrides27 === void 0 ? void 0 : _clientOverrides27.conversationId) && ((_clientOverrides28 = clientOverrides) === null || _clientOverrides28 === void 0 ? void 0 : _clientOverrides28.participantId) && ((_clientOverrides29 = clientOverrides) === null || _clientOverrides29 === void 0 ? void 0 : _clientOverrides29.mode)) {
        adaptedConfigs.conversationId = clientOverrides.conversationId;
        adaptedConfigs.participantId = clientOverrides.participantId;
        adaptedConfigs.mode = clientOverrides.mode;
    }
    return adaptedConfigs;
}
function isVacInitialized() {
    return _isVacInitialized.apply(this, arguments);
}
function _isVacInitialized() {
    _isVacInitialized = _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        getInitedChatClientFromDOM()
                    ];
                case 1:
                    return [
                        2,
                        _state.sent() !== void 0
                    ];
            }
        });
    });
    return _isVacInitialized.apply(this, arguments);
}
function isVirtualAgentControlClientLegacy(virtualAgentControlClient) {
    return virtualAgentControlClient.iframeManager !== void 0 && virtualAgentControlClient.vacFrame === void 0;
}
function setVacFrameVisibilityHidden(hidden) {
    return _setVacFrameVisibilityHidden.apply(this, arguments);
}
function _setVacFrameVisibilityHidden() {
    _setVacFrameVisibilityHidden = _async_to_generator(function(hidden) {
        var initedClient, active;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        getInitedChatClientFromDOM()
                    ];
                case 1:
                    initedClient = _state.sent();
                    active = !hidden;
                    if (initedClient) {
                        if (isVirtualAgentControlClientLegacy(initedClient)) {
                            initedClient.iframeManager.iframe.hidden = hidden;
                        } else {
                            initedClient.vacFrame.setFrameActive(active);
                        }
                        return [
                            2,
                            true
                        ];
                    }
                    return [
                        2,
                        false
                    ];
            }
        });
    });
    return _setVacFrameVisibilityHidden.apply(this, arguments);
}
function openChatWidget() {
    return _openChatWidget.apply(this, arguments);
}
function _openChatWidget() {
    _openChatWidget = _async_to_generator(function() {
        var initedClient;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        getInitedChatClientFromDOM()
                    ];
                case 1:
                    initedClient = _state.sent();
                    if (initedClient) {
                        initedClient.openChatWidget();
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _openChatWidget.apply(this, arguments);
}
function setConversationContext(clientOverrides) {
    return _setConversationContext.apply(this, arguments);
}
function _setConversationContext() {
    _setConversationContext = _async_to_generator(function(clientOverrides) {
        var initedClient, _ref, intentMessage, conversationProperties, silent;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        getInitedChatClientFromDOM()
                    ];
                case 1:
                    initedClient = _state.sent();
                    _ref = clientOverrides || {}, intentMessage = _ref.intentMessage, conversationProperties = _ref.conversationProperties, silent = _ref.silent;
                    if (initedClient && (intentMessage || conversationProperties)) {
                        initedClient.setConversationContext({
                            intentMessage: intentMessage,
                            conversationProperties: conversationProperties
                        }, silent);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return _setConversationContext.apply(this, arguments);
}
// src/components/helpers/virtual-agent-event-helper.ts
var addEventHandler = function(virtualAgentClient, subscribedEvents, eventHandler, localData) {
    var _localData_localChatClientState, _localData;
    if (virtualAgentClient && subscribedEvents && eventHandler && ((_localData = localData) === null || _localData === void 0 ? void 0 : (_localData_localChatClientState = _localData.localChatClientState) === null || _localData_localChatClientState === void 0 ? void 0 : _localData_localChatClientState.isEventHandlerRegistered) === false) {
        virtualAgentClient.on(subscribedEvents, eventHandler);
    }
};
var removeEventHandler = function(query, client, virtualAgentClient, subscribedEvents, eventHandler, localData) {
    if (virtualAgentClient && localData && subscribedEvents && eventHandler) {
        virtualAgentClient.off(subscribedEvents, eventHandler);
        client.writeQuery({
            query: query,
            data: {
                localChatClientState: _object_spread_props(_object_spread({}, localData.localChatClientState), {
                    isEventHandlerRegistered: false
                })
            }
        });
    }
};
// src/components/state/virtual-agent-control-state.ts
var VirtualAgentStateEvent = /* @__PURE__ */ function(VirtualAgentStateEvent2) {
    VirtualAgentStateEvent2["VirtualAgentInitialized"] = "virtualAgentInitialized";
    VirtualAgentStateEvent2["VirtualAgentIntentMessage"] = "virtualAgentIntentMessage";
    return VirtualAgentStateEvent2;
}(VirtualAgentStateEvent || {});
var VirtualAgentControlState = /*#__PURE__*/ function() {
    "use strict";
    function VirtualAgentControlState() {
        _class_call_check(this, VirtualAgentControlState);
        __publicField(this, "data", {
            isInitialized: false
        });
        __publicField(this, "stateFieldName", "virtualAgentControlState");
        __publicField(this, "events", [
            "virtualAgentInitialized" /* VirtualAgentInitialized */ ,
            "virtualAgentIntentMessage" /* VirtualAgentIntentMessage */ 
        ]);
    }
    _create_class(VirtualAgentControlState, [
        {
            key: "update",
            value: function update(event, currentState, payload) {
                var _payload;
                if (event === "virtualAgentInitialized" /* VirtualAgentInitialized */ ) {
                    return Object.assign({}, currentState, {
                        isInitialized: true
                    });
                }
                if (event === "virtualAgentIntentMessage" /* VirtualAgentIntentMessage */  && ((_payload = payload) === null || _payload === void 0 ? void 0 : _payload.data) && payload.data.intent) {
                    return Object.assign({}, currentState, {
                        intentMessage: payload.data
                    });
                }
                return currentState;
            }
        }
    ]);
    return VirtualAgentControlState;
}();
// src/components/virtual-agent-control.tsx
var __Query = gql(_templateObject());
var __localState = gql(_templateObject1());
var defaultLocalState = {
    __typename: "LocalChatClientState",
    requested: false
};
var VirtualAgentControl = function(props) {
    var _clientOverrides_intentMessage, _clientOverrides, _clientOverrides_conversationProperties, _clientOverrides1, _clientOverrides_conversationProperties1, _clientOverrides2;
    var applicationName = props.applicationName, clientOverrides = props.clientOverrides, pageName = props.pageName, skipSsr = props.skipSsr;
    var context = useBexApi().context;
    var _useLogger = useLogger(), logError = _useLogger.error, logInfo = _useLogger.info;
    var locale = context.locale;
    var variables = {
        context: context,
        applicationName: applicationName
    };
    var _React_useState = _sliced_to_array(React.useState(), 2), virtualAgentClient = _React_useState[0], setVirtualAgentClient = _React_useState[1];
    var _React_useState1 = _sliced_to_array(React.useState(false), 2), isInitilizing = _React_useState1[0], setIsInitilizing = _React_useState1[1];
    var _useProvidedState = _sliced_to_array(useProvidedState(), 2), dispatch = _useProvidedState[1];
    var skipQuery = Boolean(virtualAgentClient);
    var data = useQuery(__Query, {
        variables: variables,
        ssr: !skipSsr,
        skip: skipQuery
    }).data;
    var _useQuery = useQuery(__localState, {
        ssr: !skipSsr
    }), localData = _useQuery.data, client = _useQuery.client;
    var dispatchInitialized = function() {
        dispatch({
            type: "virtualAgentInitialized" /* VirtualAgentInitialized */ 
        });
    };
    var onScriptLoadError = function() {
        return logError("STRATBOT_VAC_SCRIPT_FAILED_TO_LOAD" /* STRATBOT_VAC_SCRIPT_FAILED_TO_LOAD */ );
    };
    React.useEffect(function() {
        if (!virtualAgentClient) {
            var _data;
            if (((_data = data) === null || _data === void 0 ? void 0 : _data.chatbotConfig) && (!localData || !localData.localChatClientState.requested) && !isInitilizing) {
                var _clientOverrides;
                setIsInitilizing(true);
                client.writeQuery({
                    query: __localState,
                    data: _object_spread_props(_object_spread({}, data || {}), {
                        localChatClientState: _object_spread_props(_object_spread({}, defaultLocalState), {
                            requested: true,
                            isEventHandlerRegistered: true
                        })
                    })
                });
                var chatbotConfig = data.chatbotConfig, _data_chatbotConfig = data.chatbotConfig, javascriptUrl = _data_chatbotConfig.version.javascriptUrl;
                var authToken = ((_clientOverrides = clientOverrides) === null || _clientOverrides === void 0 ? void 0 : _clientOverrides.authToken) || adaptAuthToken(chatbotConfig.authToken);
                var clientConfig = adaptChatbotConfig(chatbotConfig, pageName, locale, authToken, clientOverrides);
                var onScriptLoad = function() {
                    getChatClientFromDOM(authToken).then(function(chatClientFromDOM) {
                        if (chatClientFromDOM) {
                            chatClientFromDOM.initialize(clientConfig).then(function() {
                                getInitedChatClientFromDOM().then(function(instance) {
                                    if (instance) {
                                        setVirtualAgentClient(instance);
                                        dispatchInitialized();
                                        logInfo("STRATBOT_VAC_INIT_SUCCEEDED" /* STRATBOT_VAC_INIT_SUCCEEDED */ );
                                    } else {
                                        logError("STRATBOT_VAC_INIT_NO_VALID_CHAT_CLIENT_FOUND" /* STRATBOT_VAC_INIT_NO_VALID_CHAT_CLIENT_FOUND */ );
                                    }
                                });
                            }).catch(function(error) {
                                logError("STRATBOT_VAC_INIT_FAILED" /* STRATBOT_VAC_INIT_FAILED */ , error);
                            });
                        } else {
                            logError("STRATBOT_VAC_FAILED_TO_FIND_INSTANCE_TO_INIT" /* STRATBOT_VAC_FAILED_TO_FIND_INSTANCE_TO_INIT */ );
                        }
                    }).catch(function(error) {
                        logError("STRATBOT_VAC_ERROR_GETTING_INSTANCE_TO_INIT" /* STRATBOT_VAC_ERROR_GETTING_INSTANCE_TO_INIT */ , error);
                    });
                };
                document.head.appendChild(makeScript(javascriptUrl.value, onScriptLoad, onScriptLoadError));
            } else {
                getInitedChatClientFromDOM().then(function(instance) {
                    if (instance) {
                        setVirtualAgentClient(instance);
                        dispatchInitialized();
                    }
                });
            }
        }
    }, [
        virtualAgentClient,
        data,
        localData,
        isInitilizing,
        client,
        pageName,
        locale,
        clientOverrides,
        dispatchInitialized,
        logError,
        logInfo,
        onScriptLoadError
    ]);
    React.useEffect(function() {
        var _ref = clientOverrides || {}, intentMessage = _ref.intentMessage, conversationProperties = _ref.conversationProperties, _ref_silent = _ref.silent, silent = _ref_silent === void 0 ? true : _ref_silent;
        if (virtualAgentClient && (intentMessage || conversationProperties)) {
            var extendedConversationProperties = Object.assign(conversationProperties || {}, {
                pageName: pageName
            });
            virtualAgentClient.setConversationContext({
                intentMessage: intentMessage,
                conversationProperties: extendedConversationProperties
            }, silent);
        }
    }, [
        (_clientOverrides = clientOverrides) === null || _clientOverrides === void 0 ? void 0 : (_clientOverrides_intentMessage = _clientOverrides.intentMessage) === null || _clientOverrides_intentMessage === void 0 ? void 0 : _clientOverrides_intentMessage.intent,
        (_clientOverrides1 = clientOverrides) === null || _clientOverrides1 === void 0 ? void 0 : (_clientOverrides_conversationProperties = _clientOverrides1.conversationProperties) === null || _clientOverrides_conversationProperties === void 0 ? void 0 : _clientOverrides_conversationProperties.launchPoint,
        (_clientOverrides2 = clientOverrides) === null || _clientOverrides2 === void 0 ? void 0 : (_clientOverrides_conversationProperties1 = _clientOverrides2.conversationProperties) === null || _clientOverrides_conversationProperties1 === void 0 ? void 0 : _clientOverrides_conversationProperties1.skipWelcome
    ]);
    var _ref = clientOverrides || {}, subscribedEvents = _ref.subscribedEvents, eventHandler = _ref.eventHandler;
    var eventHandlerMemo = React.useMemo(function() {
        return eventHandler;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    React.useEffect(function() {
        addEventHandler(virtualAgentClient, subscribedEvents, eventHandlerMemo, localData);
        return function() {
            removeEventHandler(__localState, client, virtualAgentClient, subscribedEvents, eventHandlerMemo, localData);
        };
    }, [
        virtualAgentClient,
        subscribedEvents,
        eventHandlerMemo,
        localData,
        client
    ]);
    return null;
};
VirtualAgentControl.displayName = "sharedui-VirtualAgentControl";
export { VirtualAgentControl, VirtualAgentControlState, VirtualAgentStateEvent, isVacInitialized, openChatWidget, setConversationContext, setVacFrameVisibilityHidden };
//# sourceMappingURL=index.js.map